import { list as getList } from "~/api/contractStorage";
import * as types from "../mutation-types";
import store from "../../store";
import { entityStoreStatus } from "~/mixins/entityStoreStatus";
import { listMetrics } from "~/api/contractStorage";
import { clearableStore } from "~/mixins/clearableStore";

/**
 * Initial state
 */
export const state = {
  list: null,
  isLoading: false,
  metrics: null,
  isInitialLoadPending: true
};

/**
 * Mutations
 */
export const mutations = {
  ...clearableStore.mutations,
  [types.SET_IS_LOADING_CONTRACT_STORAGE](state, status) {
    state.isLoading = status;
  },
  [types.SET_CONTRACT_STORAGE](state, contractStorage) {
    state.list = contractStorage.data;
    state.isInitialLoadPending = false;
  },
  [types.SET_STORAGE_METRIC](state, data) {
    const incoming = Array.isArray(data?.data) ? data.data : [];

    if (!state.metrics || !Array.isArray(state.metrics)) {
      state.metrics = incoming;
      return;
    }

    const byId = {};

    state.metrics.forEach((m) => {
      if (m && m.id !== undefined && !(m.id in byId)) {
        byId[m.id] = m;
      }
    });

    incoming.forEach((m) => {
      if (m && m.id !== undefined) {
        byId[m.id] = m;
      }
    });

    state.metrics = Object.values(byId);
  }
};

/**
 * Actions
 */
export const actions = {
  fetchContractStorages({ commit }, contractId = null) {
    commit(types.SET_IS_LOADING_CONTRACT_STORAGE, true);

    let activeContractId =
      contractId || store.getters["contract/activeContract"]?.id;

    if (activeContractId) {
      getList(activeContractId).then((response) => {
        let { data } = response;
        commit(types.SET_CONTRACT_STORAGE, data);
        commit(types.SET_IS_LOADING_CONTRACT_STORAGE, false);
      });
    }
  },
  async fetchStoragesMetrics({ commit }, contractId = null) {
    try {
      let activeContractId =
        contractId || store.getters["contract/activeContract"]?.id;

      await listMetrics(activeContractId).then(({ data }) => {
        commit(types.SET_STORAGE_METRIC, data);
      });
    } catch (e) {
      // commit(types.FETCH_USER_FAILURE);
    }
  },
};

/**
 * Getters
 */
export const getters = {
  list: (state) => state.list,
  isLoading: (state) => state.isLoading,
  isInitialLoadPending: (state) => state.isInitialLoadPending,
  metrics: (state) => state.metrics,
  getMetrics: (state) => (id) => {
    const metric = state.metrics?.find(b => b.id === id);
    return metric ?? null;
  },
  ...entityStoreStatus.getters
};
